/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { fetchData, limitLength, toasterrormsg } from '../../../../reusable'
import { KTIcon, toAbsoluteUrl } from '../../../helpers'
import { Tr } from '../../../i18n/Tr'
import { Dropdown1 } from '../../content/dropdown/Dropdown1'

type Props = {
  className: string
  color: string
  hotelId: string
  hotelName: string
  image: string
  description: string
  numOfRooms: string
  propertyType: string
  progress: string
  deleteHotel: any
  businessInfostatus?: string
  businessRejectReason?: string
  checkInOutTime?: string
}

const MixedWidget16: React.FC<Props> = ({ className, color, hotelId, hotelName, image, description, numOfRooms, propertyType, progress, deleteHotel, businessInfostatus, businessRejectReason, checkInOutTime }) => {  
  const t = Tr()
  return (
    <div className={`card ${className}`}>
      {/* begin::Body */}
      <div className='card-body'>
        {/* begin::Heading */}
        <div className='d-flex flex-stack'>
          {/* begin:Info */}
          <div className='d-flex align-items-center'>
            {/* begin:Image */}
            <div className='symbol symbol-60px me-5'>
              <span className={clsx(`symbol-label`, `bg-${color}-light`)}>
                <img src={image} className='h-55px w-100 rounded align-self-center' alt='' />
              </span>
            </div>
            {/* end:Image */}

            {/* begin:Title */}
            <div className='d-flex flex-column flex-grow-1 my-lg-0 my-2 pr-3'>
              <Link to='../hoteloverview/' state={{ hotelId: hotelId }} className='text-dark fw-bold text-hover-primary fs-5'>
                {limitLength(hotelName, 22)}
              </Link>

              {/* <span className='text-muted fw-semibold'>{propertyType}</span> */}
              <span className='badge badge-light-success me-auto mt-1'>{propertyType}</span>
            </div>
            {/* end:Title */}
          </div>
          {/* begin:Info */}

          {/* begin:Menu */}
          <div className='ms-1'>
            <Link
              to={'../addhotelbasicinfo/'}
              state={{ hotelId: hotelId }}
              onClick={() => sessionStorage.removeItem('indexTab')}
              className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
              data-kt-menu-trigger='click'
              data-kt-menu-placement='bottom-end'
              data-kt-menu-flip='top-end'
            >
              <KTIcon iconName='notepad-edit' className='fs-2' />
            </Link>
            <button
              onClick={() => deleteHotel(hotelId)}
              className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
              data-kt-menu-trigger='click'
              data-kt-menu-placement='bottom-end'
              data-kt-menu-flip='top-end'
            >
              <KTIcon iconName='trash-square' className='fs-2' />
            </button>
          </div>
          {/* end::Menu */}
        </div>
        {/* end::Heading */}

        {/* begin:Stats */}
        <div className='d-flex flex-column w-100 mt-10'>
          <div className='text-dark me-2 fw-bold pb-0'>{t('Verification Status')}</div>
          {
            businessInfostatus == '0' && (
              <span className='badge badge-light-warning me-auto mb-2'>{t('Pending')}</span>
            )
          }
          {
            businessInfostatus == '1' && (
              <span className='badge badge-light-success me-auto mb-2'>{t('Approved')}</span>
            )
          }
          {
            businessInfostatus == '2' && (
              <>
                <span className='badge badge-light-danger me-auto mb-2'>{t('Rejected')}</span>
                <div className="dropzone border-danger bg-light-danger mb-2" id="kt_ecommerce_add_reject_reason">
                  <div className="dz-message needsclick">
                    {/* <!--begin::Icon--> */}
                    <i className="fas fa-info-circle text-danger fs-5 mt-1"></i>
                    <div className="ms-4">
                      <span className="fs-7 fw-semibold text-gray-600">{businessRejectReason}</span>
                    </div>
                  </div>
                </div>
              </>

            )
          }
          {/* <span className='text-dark me-2 fw-bold pb-3'>Progress</span> */}
          <div className='progress h-5px w-100'>
            <div
              className={`progress-bar bg-${color}`}
              role='progressbar'
              style={{ width: progress }}
            ></div>
          </div>
        </div>
        {/* end:Stats */}

        {/* begin:Team */}
        <div className='d-flex flex-column mt-10'>
          <div className='text-dark me-2 fw-bold pb-0'>{t('Number of rooms')}</div>
          <span className='text-muted fw-semibold mb-5'>{numOfRooms}</span>
          <div className='text-dark me-2 fw-bold pb-0'>{t('Check in - Check Out time')}</div>
          <span className='text-muted fw-semibold mb-5'>{checkInOutTime}</span>
          <div className='text-dark me-2 fw-bold pb-1'>{t('Description')}</div>
          <span className='text-muted fw-semibold'><div dangerouslySetInnerHTML={{ __html: limitLength(description, 110) }}></div> </span>
        </div>
        {/* end:Team */}
      </div>
      {/* end::Body */}
    </div>
  )
}

export { MixedWidget16 }
